import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { Router, RouterModule } from '@angular/router';
import { O365AuthService, ROLES } from '../../../services/o365-auth.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-header',
  imports: [
    MatIconModule,
    MatToolbarModule,
    MatButtonModule,
    MatMenuModule,
    CommonModule,
    RouterModule
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  ROLES = ROLES;
  instance_name: string = environment.env_name ?? 'none';
  
  constructor(private authService: O365AuthService, private router: Router) { }

  get signedIn(): boolean {
    return this.authService.signedIn;
  }

  get username(): string | null {
    return this.authService.username;
  }

  get userrole(): string[] {
    return this.authService.userRoles();
  }

  get userRoles(): string {
    return this.authService.userRoles().slice().sort().join(', ');
  }

  login() {
    console.log("login clicked");
    this.authService.msalService.loginRedirect();
  }

  signOut() {
    console.log("logout clicked");
    this.authService.logout();
    this.router.navigate(['/welcome']);
  }
}
